/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const justifySpaceBetween = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M9 15h6V9H9v6zm-5 5h1.5V4H4v16zM18.5 4v16H20V4h-1.5z" />
	</SVG>
);

export default justifySpaceBetween;
